import z from "zod";

import { CARD_BORDERS, CARD_GLOWS } from "./constants";

const booleanAttribute = z
  .string()
  .optional()
  .transform((value) => value !== undefined && value !== "false");

export const cardDataSchema = z.object({
  glow: z.enum(CARD_GLOWS).optional(),
  border: z.enum(CARD_BORDERS).optional(),
  disabled: booleanAttribute,
  color: z.string().optional(),
  size: z.coerce.number().optional(),
  radius: z.coerce.number().optional(),
  blur: z.coerce.number().optional(),
  borderWidth: z.coerce.number().optional(),
  intensity: z.coerce.number().optional(),
});

export type CardDataProps = z.infer<typeof cardDataSchema>;
